import type { SVGProps } from 'react';
const SvgGrossMotor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#gross-motor_svg__a)"
    >
      <path d="M9.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM3.5 6.6s2-1.604 5 .438c3.154 2.143 5 1.303 5 1.303M6.915 10.072C8.029 10.313 11 11.25 11 14.5" />
      <path d="M8.402 6.97C8.024 8.452 6.176 12.917 2 12.5" />
    </g>
    <defs>
      <clipPath id="gross-motor_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGrossMotor;
